import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

/** Shared reading width for every authenticated Nafa page. */
export const NAFA_PAGE_WIDTH = "mx-auto w-full max-w-[1180px]";

/** Shared width for task forms inside the page shell. */
export const NAFA_FORM_WIDTH = "w-full max-w-3xl";

export function PageContainer({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn(NAFA_PAGE_WIDTH, className)}>{children}</div>;
}
